import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { Footer } from './Footer';
import commonSidebarLayout from './commonSidebarLayout';
import { SidebarMenusList } from './SidebarMenusList';
import k12LogoDesktop from '../assets/images/k12-logo-white.svg';
import '../assets/css/sidebar.css'; 

const Sidebar: React.FC<{ bgColor?: string; textColor1?: string; textColor2?: string;textColor3?: string; isMobile?: boolean }> = ({
    bgColor = '',
    textColor1 = '',
    textColor2 = '',
    textColor3 = '',
    isMobile = false,
  }) => {

    const [schoolPrepOpen, setSchoolPrepOpen] = useState(false);
    const [coachLifeOpen, setCoachLifeOpen] = useState(false);
    const [onlineSchoolOpen, setOnlineSchoolOpen] = useState(false);

    const [openMenu, setOpenMenu] = useState<string | null>(null);
    const toggleMenu = (menuName: string) => {
      console.log(menuName);
      setOpenMenu(openMenu === menuName ? null : menuName);
    };
    
    return (
      <aside className={`sidebar widget-area bg-color-blue-4 ${bgColor}`}>
        <div className={`sidebar-list ${bgColor}`}>
          <div className="row">
            <div className="col-12 p-0 text-center">
              {/* logo */}
              <a className="text-center d-none d-md-block" id="logo-div" href="/">
                <img src={k12LogoDesktop} alt="K12 Onboarding" className="img-fluid logo" />
              </a>
              <SidebarMenusList
                bgColor={bgColor}
                textColor1={textColor1}
                textColor2={textColor2}
                textColor3={textColor3}
                isMobile={isMobile}
              />
              
            </div>
          </div>
        </div>
        <Footer />
      </aside>
    );
};


  // return (
  //   <aside className="sidebar widget-area bg-color-blue-4">
  //     <div className="container-fluid">
  //       <div className="row">
  //         <div className="col-12 p-0">
  //           {/* logo */}
  //           <a className="text-center d-block" href="#">
  //             <img src="https://welcome.k12.com/wp-content/themes/k12-onboarding-theme/dist/images/logo-white.svg" alt="K12 Onboarding" className="img-fluid logo" />
  //           </a>
  //           <nav className="main-menu-container primary-menu">
  //             <ul className="menu">
  //               <li className="menu-item">
  //                 <NavLink
  //                   to="/onboarding"
  //                   className={({ isActive }) => (isActive ? 'active' : '')}
  //                 >
  //                   <i className="fas fa-home menu-icon"></i><span>Overview</span> 
  //                 </NavLink>
  //               </li>
  //               <li className="menu-item">
  //                 <NavLink
  //                   to="/school-prep-checklist"
  //                   className={({ isActive }) => (isActive ? 'active' : '')}
  //                 >
  //                   <i className="fas fa-check-circle menu-icon"></i> <span> School Prep Checklist </span>
  //                 </NavLink>
                
  //                 <ul className="inner-menu-list">
  //                   <li className="menu-item">
  //                       <a className="submenu-head" onClick={() => setSchoolPrepOpen(!schoolPrepOpen)}
  //                           >
  //                           Forms & Documents
  //                           <i className={`fas ${schoolPrepOpen ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i>
  //                       </a>

  //                     {schoolPrepOpen && (
  //                       <ul className="submenu-item">
  //                         <li>
  //                           <NavLink
  //                             to="/k12-checklist-category/forms-and-documents/"
  //                             className={({ isActive }) => (isActive ? 'active' : '')}
  //                           >
  //                             <b>View All</b>
  //                           </NavLink>
  //                         </li>
  //                         <li>
  //                           <NavLink
  //                             to="/k12-checklist/school-documents/"
  //                             className={({ isActive }) => (isActive ? 'active' : '')}
  //                           >
  //                             School Documents
  //                           </NavLink>
  //                         </li>
  //                         <li>
  //                           <NavLink
  //                             to="/k12-checklist/consent-process"
  //                             className={({ isActive }) => (isActive ? 'active' : '')}
  //                           >
  //                             Consent Process
  //                           </NavLink>
  //                         </li>
  //                       </ul>
  //                     )}
  //                   </li>
  //                   <li className="menu-item">
  //                       <a className="submenu-head" onClick={() => setCoachLifeOpen(!coachLifeOpen)}
  //                           >
  //                           Learning Coach Life
  //                           <i className={`fas ${coachLifeOpen ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i>
  //                       </a>

  //                     {coachLifeOpen && (
  //                       <ul className="submenu-item">
  //                         <li>
  //                           <NavLink
  //                             to="/k12-checklist-category/learning-coach-life/"
  //                             className={({ isActive }) => (isActive ? 'active' : '')}
  //                           >
  //                             <b>View All</b>
  //                           </NavLink>
  //                         </li>
  //                         <li>
  //                           <NavLink
  //                             to="/k12-checklist/what-is-a-learning-coach/"
  //                             className={({ isActive }) => (isActive ? 'active' : '')}
  //                           >
  //                             What is a Learning Coach?
  //                           </NavLink>
  //                         </li>
  //                         <li>
  //                           <NavLink
  //                             to="/k12-checklist/what-does-a-learning-coach-do/"
  //                             className={({ isActive }) => (isActive ? 'active' : '')}
  //                           >
  //                             What does a Learning Coach do?
  //                           </NavLink>
  //                         </li>
  //                       </ul>
  //                     )}
  //                   </li>
  //                   <li className="menu-item">
  //                     <a className="submenu-head" onClick={() => toggleMenu('onlineschool')}>
  //                     Online School
  //                       <i className={`fas ${openMenu === 'onlineschool' ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i>
  //                     </a>

  //                     {openMenu === 'onlineschool' && (
  //                       <ul className="submenu-item">
  //                         <li>
  //                           <NavLink
  //                             to="/k12-checklist-category/learning-coach-life/"
  //                             className={({ isActive }) => (isActive ? 'active' : '')}
  //                           >
  //                             <b>View All</b>
  //                           </NavLink>
  //                         </li>
  //                         <li>
  //                           <NavLink
  //                             to="/k12-checklist/school-start-faqs/"
  //                             className={({ isActive }) => (isActive ? 'active' : '')}
  //                           >
  //                             School Start FAQs
  //                           </NavLink>
  //                         </li>
  //                         <li>
  //                           <NavLink
  //                             to="/k12-checklist/navigating-the-online-school/"
  //                             className={({ isActive }) => (isActive ? 'active' : '')}
  //                           >
  //                             Navigating the Online School
  //                           </NavLink>
  //                         </li>
  //                         <li>
  //                           <NavLink
  //                             to="/k12-checklist/sample-lessons/"
  //                             className={({ isActive }) => (isActive ? 'active' : '')}
  //                           >
  //                             Sample Lessons
  //                           </NavLink>
  //                         </li>
  //                       </ul>
  //                     )}
  //                   </li>
  //                   <li className="menu-item">
  //                     <a className="submenu-head" onClick={() => toggleMenu('emailsetup')}>
  //                       Email Setup
  //                       <i className={`fas ${openMenu === 'emailsetup' ? 'fa-chevron-up' : 'fa-chevron-down'}`}></i>
  //                     </a>

  //                     {openMenu === 'emailsetup' && (
  //                       <ul className="submenu-item">
  //                         <li>
  //                           <NavLink
  //                             to="/k12-checklist-category/learning-coach-life/"
  //                             className={({ isActive }) => (isActive ? 'active' : '')}
  //                           >
  //                             <b>View All</b>
  //                           </NavLink>
  //                         </li>
  //                         <li>
  //                           <NavLink
  //                             to="/k12-checklist/email-basics/"
  //                             className={({ isActive }) => (isActive ? 'active' : '')}
  //                           >
  //                             Email Basics
  //                           </NavLink>
  //                         </li>
  //                         <li>
  //                           <NavLink
  //                             to="/k12-checklist/email-options/"
  //                             className={({ isActive }) => (isActive ? 'active' : '')}
  //                           >
  //                             Email Options
  //                           </NavLink>
  //                         </li>
  //                         <li>
  //                           <NavLink
  //                             to="/k12-checklist/sample-lessons/"
  //                             className={({ isActive }) => (isActive ? 'active' : '')}
  //                           >
  //                             Sample Lessons
  //                           </NavLink>
  //                         </li>
  //                       </ul>
  //                     )}
  //                   </li>

  //                 </ul>
  //               </li>
                
  //               <li className="menu-item">
  //                 <NavLink
  //                   to="/learning-materials"
  //                   className={({ isActive }) => (isActive ? 'active' : '')}
  //                 >
  //                   <i className="fas fa-book"></i> Learning Materials
  //                 </NavLink>
  //               </li>

  //               <li className="menu-item">
  //                 <NavLink
  //                   to="/community"
  //                   className={({ isActive }) => (isActive ? 'active' : '')}
  //                 >
  //                   <i className="fas fa-users"></i>Community
  //                 </NavLink>
               
  //                 <ul className="inner-menu-list">
  //                   <li className="menu-item">
  //                     <NavLink
  //                       to="/community/learning-coach-community"
  //                       className={({ isActive }) => (isActive ? 'active' : '')}
  //                     >
  //                       Learning Coach Community
  //                     </NavLink>
  //                   </li>
  //                   <li className="menu-item">
  //                     <NavLink
  //                       to="/community/k12-zone"
  //                       className={({ isActive }) => (isActive ? 'active' : '')}
  //                     >
  //                       Hang Out in the K12 Zone
  //                     </NavLink>
  //                   </li>
  //                 </ul>
  //               </li>


  //               <li className="menu-item">
  //                 <NavLink
  //                   to="/contact"
  //                   className={({ isActive }) => (isActive ? 'active' : '')}
  //                 >
  //                   <i className="fas fa-address-book"></i> Contact
  //                 </NavLink>
  //               </li>

  //             </ul>
  //           </nav>
  //         </div>
  //       </div>
  //     </div>
  //     <Footer />
  //   </aside>
  // );


// Wrap with HOC
export default commonSidebarLayout(Sidebar);

// export default Sidebar;
